import React from "react";
import "./footer.css";

export const Footer = () => {
  return (
    <React.Fragment>
      <footer>
        <a
          href="https://unclebigbay.com/introducing-the-anonymous-feedback-platform-powered-by-the-chern-stack"
          className="article-link"
        >
          Read article
        </a>
        <a
          href="https://www.youtube.com/watch?v=KKoKh5U9_XQ"
          className="youtube-link"
        >
          Watch demo
        </a>
        <a
          href="https://anonymousfeedback.tk/to/unclebigbay"
          className="give-us-feedback-link"
        >
          Give feedback about this product
        </a>
        <div className="buttons">
          <a
            className="coffee-btn"
            href="https://www.buymeacoffee.com/unclebigbay"
          >
            <img
              alt="buy me a coffee"
              style={{ width: "200px", height: "54px" }}
              src="https://img.buymeacoffee.com/button-api/?text=Buy me a coffee&emoji=&slug=unclebigbay&button_colour=5F7FFF&font_colour=ffffff&font_family=Lato&outline_colour=000000&coffee_colour=FFDD00"
            />
          </a>

          <a
            href="https://www.producthunt.com/posts/anonymous-feedback?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-anonymous-feedback"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=306301&theme=light"
              alt="Anonymous Feedback - Platform to receive and send feedback anonymously | Product Hunt"
              style={{ width: "200px", height: "54px" }}
              width="200"
              height="54"
            />
          </a>
        </div>
        <span className="author">
          Designed with 💝 by{" "}
          <a
            href="https://twitter.com/intent/follow?screen_name=unclebigbay143"
            target="_blank"
            rel="noopener noreferrer"
          >
            unclebigbay
          </a>{" "}
          and friends
        </span>
      </footer>
    </React.Fragment>
  );
};
